// extracted by mini-css-extract-plugin
export default {"userVerifyContainer":"UserVerify_userVerifyContainer__SKl0J","header":"UserVerify_header__fKxGZ"};